import React, { createContext, useContext, useState } from 'react';

// Créer un contexte pour gérer le titre et le breadcrumb
const PageContext = createContext();

export const usePageContext = () => {
  return useContext(PageContext);
};

export const PageProvider = ({ children }) => {
  const [title, setTitle] = useState('');
  const [breadcrumb, setBreadcrumb] = useState([]);

  return (
    <PageContext.Provider value={{ title, setTitle, breadcrumb, setBreadcrumb }}>
      {children}
    </PageContext.Provider>
  );
};
